/* ============================================================================
   haiku-hero — rotating quote, drawn marks, and the framed CTA

   Three jobs on the HAIKÙ section, all additive:

     1. QUOTE. The section's copy is replaced with one line picked at random
        from the list in snippets/haiku-hero.liquid. Chosen in the browser
        rather than in Liquid, because Shopify serves cached HTML — a Liquid
        pick would freeze the same quote for every visitor until that cache
        expired, which is not a rotation at all.

     2. MARKS. The section has three image blocks that were left empty, so the
        theme rendered its broken-image placeholder in each. The drawings are
        injected there as real <img> elements.

     3. CTA. Class hook only; the framed look is CSS.

   FAIL-SAFE. Everything here replaces content that already exists and reads
   fine on its own. If the script never runs, the section keeps its authored
   copy and simply shows no marks — no blank page, no broken layout.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.haikuHeroConfig || {};
  if (cfg.enabled === false) return;

  var quotes = Array.isArray(cfg.quotes) ? cfg.quotes.filter(Boolean) : [];
  var marks = Array.isArray(cfg.marks) ? cfg.marks.filter(Boolean) : [];

  /* The HAIKÙ section, located by its title rather than by a generated id —
     section ids change whenever the block is re-added in the editor. */
  function section() {
    /* Matching on a title starting with "haik" caught the HEADER, because the
       logo is the word haikù. The section is identified by what only it has:
       the empty image placeholders, or a HAIKÙ title sitting next to a link
       into the wardrobe. Anything containing the header is excluded outright. */
    var all = document.querySelectorAll('.shopify-section');
    var fallback = null;

    for (var i = 0; i < all.length; i++) {
      var sec = all[i];
      if (sec.querySelector('.header-holder, main-header, .header')) continue;

      var hasPlaceholders = sec.querySelectorAll('[class*="placeholder"]').length >= 2;
      var hasCta = !!sec.querySelector('a[href*="/collections/"]');

      var titled = false;
      var nodes = sec.querySelectorAll('h1, h2, h3, span, .h1, .h2, [class*="title"]');
      for (var j = 0; j < nodes.length; j++) {
        var txt = (nodes[j].textContent || '').trim().toLowerCase();
        if (txt.length < 12 && txt.indexOf('haik') === 0) { titled = true; break; }
      }

      if (titled && (hasPlaceholders || hasCta)) return sec;
      if (hasPlaceholders && hasCta && !fallback) fallback = sec;
    }
    return fallback;
  }

  function setQuote(sec) {
    if (!quotes.length) return;
    var body = sec.querySelector('.rte, [class*="content"] p, p');
    if (!body) return;
    var pick = quotes[Math.floor(Math.random() * quotes.length)];
    if (!pick) return;
    // textContent, not innerHTML — the list is copy, never markup.
    var p = body.tagName === 'P' ? body : (body.querySelector('p') || body);
    p.textContent = pick;
    sec.setAttribute('data-hh-quote', '1');
  }

  function setMarks(sec) {
    if (!marks.length) return;
    /* The empty blocks render as the theme's placeholder — an <svg> icon with
       no <img> beside it. Those are the slots to fill. */
    /* Shopify's empty-block art is `span.onboarding-svg`, NOT placeholder-*.
       That naming difference is why the marks silently never landed. Both are
       matched now so this keeps working if the theme changes which it uses. */
    var slots = sec.querySelectorAll(
      '.onboarding-svg, .placeholder-svg, .placeholder-background, [class*="placeholder"]'
    );
    var filled = 0;

    for (var i = 0; i < slots.length && filled < marks.length; i++) {
      var slot = slots[i];
      if (slot.getAttribute('data-hh-mark')) continue;
      var host = slot.parentNode;
      if (!host) continue;
      /* Sized boxes only — skip decorative icons that happen to share the
         class. MEASURED: 60 was taken from a desktop viewport, where these
         placeholders are large. On a 430px phone the very same slots are
         49x49, so every one of them was skipped and the marks never landed —
         which is why the section showed Shopify's placeholder art on mobile
         and the drawn marks on desktop. 32 still excludes real icons (the
         header's are 22px) while accepting the phone-sized slots. */
      var sb = slot.getBoundingClientRect();
      if (sb.width < 32 || sb.height < 32) continue;

      var img = document.createElement('img');
      img.className = 'hh-mark';
      img.src = marks[filled];
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      /* haiku-modes.css dims every <img> in main to brightness(0.96) in dark
         mode — right for photography, wrong for black line art, which needs
         inverting instead. That rule scores (0,3,3) and any sane selector for
         these marks scores less, so rather than escalate specificity this uses
         the escape hatch the modes layer documents for exactly this case. */
      img.setAttribute('data-haiku-modes-exempt', '');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');

      slot.setAttribute('data-hh-mark', '1');
      slot.style.display = 'none';
      host.appendChild(img);
      filled++;
    }

    if (filled) sec.setAttribute('data-hh-marks', String(filled));
  }

  function boot() {
    var sec = section();
    if (!sec) return;
    sec.classList.add('hh');
    try { setQuote(sec); } catch (e) { /* copy stays as authored */ }
    try { setMarks(sec); } catch (e) { /* placeholders stay */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // The section's own scripts may re-render the blocks after first paint.
  window.setTimeout(boot, 600);
  window.setTimeout(boot, 1600);
})();
